import { render, staticRenderFns } from "./AgeGradingCalculator.vue?vue&type=template&id=489b0337&scoped=true&"
import script from "./AgeGradingCalculator.vue?vue&type=script&lang=js&"
export * from "./AgeGradingCalculator.vue?vue&type=script&lang=js&"
import style0 from "./AgeGradingCalculator.vue?vue&type=style&index=0&id=489b0337&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489b0337",
  null
  
)

export default component.exports